<template>
  <v-container fluid class="mt-6" :class="open ? 'pt-0' : 'pa-0'"
    :style="open ? 'border: 1px solid var(--v-primary-base) !important; border-radius: 6px;' : ''">
    <v-row no-gutters>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn outlined color="primary" class="mt-n8" style="border: none !important; text-transform: none !important;" @click="open = !open">
          {{ $t('servicesystem.common_objects.commonterms.advanced_options') }}
          <v-icon class="ml-2" size="15">mdi-cog</v-icon></v-btn>
      </v-col>
    </v-row>
    <template v-if="open">
      <slot>
        <v-row no-gutters>
          <h1>Content</h1>
        </v-row>
      </slot>
      <v-row no-gutters>
        <v-divider></v-divider>
      </v-row>
    </template>
  </v-container>
</template>


<script>
export default {
  name: 'AdvancedExpancion',
  props: {

  },
  components: {},

  data() {
    return {
      open: false,
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>